/**
 * API Configuration - Uses centralized serverConfig
 * No more hardcoded URLs!
 */

import { BRIDGE_API_URL, BRIDGE_API_BASE, getServerEnvironmentInfo } from './serverConfig';

// Get current API URL
export function getApiUrl(): string {
  return BRIDGE_API_URL;
}

// Get base API URL (without the PHP file)
export function getApiBaseUrl(): string {
  return BRIDGE_API_BASE;
}

// Get environment info
export function getEnvironmentInfo() {
  const info = getServerEnvironmentInfo();
  return {
    url: BRIDGE_API_URL,
    baseUrl: BRIDGE_API_BASE,
    isDev: info.isDev,
    isProduction: !info.isDev,
    label: info.label,
    shortLabel: info.shortLabel,
  };
}

// Legacy compatibility stubs
export type ApiEnvironment = 'dev';
export function getApiEnvironment(): ApiEnvironment {
  return 'dev';
}
export function setApiEnvironment(_env: ApiEnvironment): void {}
export function getAvailableEnvironments() {
  return [
    { value: 'dev' as ApiEnvironment, label: getServerEnvironmentInfo().label, url: BRIDGE_API_URL },
  ];
}
export function setProdMode(_enabled: boolean): void {}
export function setDevMode(_enabled: boolean): void {}
